import { Method, send } from '../../lib/MyHttp';

/**
 * 리스트
 */
export const GetList = (component, params, success, fail) => {
    let paramsT = { ...params };
    if (!params['type']) delete paramsT['type'];
    if (!params['branchId']) delete paramsT['branchId'];
    if (!params['driverId']) delete paramsT['driverId'];
    if (!params['buld_nm']) delete paramsT['buld_nm'];
    if (!params['inspct_dt'][0] || !params['inspct_dt'][1]) delete paramsT['inspct_dt'];

    send(component, Method.GET, '/a/batcha', paramsT, success, fail);
};

/**
 * 엑셀 다운로드
 */
export const GetListDownload = (component, params, success, fail) => {
    let paramsT = { ...params };
    if (!params['type']) delete paramsT['type'];
    if (!params['branchId']) delete paramsT['branchId'];
    if (!params['driverId']) delete paramsT['driverId'];
    if (!params['buld_nm']) delete paramsT['buld_nm'];
    if (!params['inspct_dt'][0] || !params['inspct_dt'][1]) delete paramsT['inspct_dt'];

    send(component, Method.GET, '/a/batcha/download', paramsT, success, fail);
};

/**
 * 정보
 */
export const Get = (component, id, success, fail) => {
    const params = {};
    send(component, Method.GET, '/a/batcha/' + id, params, success, fail);
};

/**
 * 등록
 */
export const Create = (component, params, success, fail) => {
    const paramsT = {
        type: params.type,
        recptn_cnt: params.recptn_cnt,
        recptn_no: params.recptn_no,
        bal_engr_nm: params.bal_engr_nm,
        inspct_odr: params.inspct_odr,
        buld_nm: params.buld_nm,
        bal_car_alct_seq: params.bal_car_alct_seq,
        ispt_chk_sign_url: params.ispt_chk_sign_url,
        pos_cpny_cd: params.pos_cpny_cd,
        ledg_mnfctur_company_nm: params.ledg_mnfctur_company_nm,
        pos_chk: params.pos_chk,
        ledg_mnfctur_hedofc_telno: params.ledg_mnfctur_hedofc_telno,
        ledg_live_load: params.ledg_live_load,
        ledg_mnt_cpny_info: params.ledg_mnt_cpny_info,
        virtl_team: params.virtl_team,
        inspct_instt_cd: params.inspct_instt_cd,
        recptn_de: params.recptn_de,
        rn: params.rn,
        reqst_mnfctur_cpny_info: params.reqst_mnfctur_cpny_info,
        cstmr_guidance_no: params.cstmr_guidance_no,
        ledg_mnfctur_cpny_info: params.ledg_mnfctur_cpny_info,
        main_inspctr_nm: params.main_inspctr_nm,
        main_inspctr_exc: params.main_inspctr_exc,
        ledg_elvtr_div: params.ledg_elvtr_div,
        inspct_dt: params.inspct_dt,
        address: params.address,
        reqst_live_load: params.reqst_live_load,
        partcpnt_telno_2: params.partcpnt_telno_2,
        bal_engr_mobile_no: params.bal_engr_mobile_no,
        agency_instt_cd: params.agency_instt_cd,
        ispt_chk_n_cnt: params.ispt_chk_n_cnt,
        sido: params.sido,
        inspct_kind_nm: params.inspct_kind_nm,
        reqst_elvtr_div: params.reqst_elvtr_div,
        reqst_mnfctur_company_nm: params.reqst_mnfctur_company_nm,
        inspct_instt_nm: params.inspct_instt_nm,
        solo_gubun: params.solo_gubun,
        reqst_mnfctur_company_telno: params.reqst_mnfctur_company_telno,
        ledg_mnt_company_nm: params.ledg_mnt_company_nm,
        sigungu: params.sigungu,
        ledg_elvtr_form: params.ledg_elvtr_form,
        ispt_chk_yn_txt: params.ispt_chk_yn_txt,
        ledg_mnt_hedofc_telno: params.ledg_mnt_hedofc_telno,
        bal_engr_seq: params.bal_engr_seq,
        rnum: params.rnum,
        main_inspctr_tel: params.main_inspctr_tel,
        reqst_elvtr_form: params.reqst_elvtr_form,
        bal_car_no: params.bal_car_no,
        asign_de: params.asign_de,
        ispt_chk_yn: params.ispt_chk_yn,
        reqst_id: params.reqst_id,
        bal_engr_exc: params.bal_engr_exc,
        reqst_de: params.reqst_de,
        post_address: params.post_address,
        partcpnt_telno_1: params.partcpnt_telno_1,
        reqst_nm: params.reqst_nm,
        receiptAt: params.receiptAt,
        ispt_chk_dt: params.ispt_chk_dt,
        elevatorId: params.elevatorId,
        fax: params.fax,
        phone: params.phone,
        branchId: params.branchId,
        driverId: params.driverId,
        manager1Id: params.manager1Id,
        manager2Id: params.manager2Id,
        manager3Id: params.manager3Id,
        placemanager1Id: params.placemanager1Id,
        pay: params.pay,
        fm: params.fm,
        status: params.status,
    };

    send(component, Method.POST, '/a/batcha/', paramsT, success, fail);
};

/**
 * 업데이트
 */
export const Update = (component, id, params, success, fail) => {
    const paramsT = {
        ...params,
    };

    delete paramsT['id'];
    delete paramsT['createdAt'];
    delete paramsT['updatedAt'];

    send(component, Method.PUT, '/a/batcha/' + id, paramsT, success, fail);
};

/**
 * 업데이트
 */
export const UpdateAll = (component, params, success, fail) => {
    const paramsT = {
        data: params,
    };

    send(component, Method.PUT, '/a/batcha/updateAll', paramsT, success, fail);
};

/**
 * 삭제
 */
export const Delete = (component, id, success, fail) => {
    const params = {};
    send(component, Method.DELETE, '/a/batcha/' + id, params, success, fail);
};

/**
 * 삭제
 */
export const DeleteArray = (component, ids, success, fail) => {
    const params = { id: ids };
    send(component, Method.DELETE, '/a/batcha/', params, success, fail);
};

/**
 * 불러오기
 */
export const Crawling = (component, from, to, success, fail) => {
    const params = {
        from,
        to,
    };
    send(component, Method.POST, '/a/batcha/crawling', params, success, fail);
};
